import React from "react";

const ServiceMainPagePopupHappy = (props) => {
    return (
        <React.Fragment>
            <div className="service-popup-happy-state-wrap">
                <p>{props.description}</p>
            </div>
        </React.Fragment>
    )
};

export default ServiceMainPagePopupHappy;